import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Truck, Shield, Clock, Package } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Hero = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/29399463/pexels-photo-29399463.jpeg"
          alt="Caminhão Mercedes-Benz ou Volkswagen"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-gray-900/70"></div>
      </div>

      {/* Floating Cards */}
      <div className="absolute top-20 right-10 animate-float hidden lg:block">
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 shadow-2xl">
          <Package className="text-red-500 mb-2" size={32} />
          <p className="text-white font-bold text-lg">+1000</p>
          <p className="text-white/80 text-sm">Produtos</p>
        </div>
      </div>

      <div className="absolute bottom-32 right-20 animate-float-delayed hidden lg:block">
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 shadow-2xl">
          <Truck className="text-gray-400 mb-2" size={32} />
          <p className="text-white font-bold text-lg">Entrega</p>
          <p className="text-white/80 text-sm">Rápida</p>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 z-10">
        <div className="max-w-3xl">
          {/* Content */}
          <div className="space-y-8 animate-in fade-in slide-in-from-left duration-700">
            <div className="inline-block">
              <span className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-wider">
                Soluções em Autopeças para Caminhões e Ônibus
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Garantimos que sua{' '}
              <span className="text-red-500">operação não pare</span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-200 leading-relaxed">
              Fornecimento de peças originais e genuínas para frotas do mercado industrial, transportadoras e lojas de autopeças. 
              <span className="font-semibold text-white"> Qualidade, disponibilidade e eficiência logística.</span>
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 py-6">
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-red-600 rounded-lg mx-auto mb-2">
                  <Shield className="text-white" size={24} />
                </div>
                <div className="text-2xl font-bold text-white">100%</div>
                <div className="text-sm text-gray-300">Confiáveis</div>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-gray-700 rounded-lg mx-auto mb-2">
                  <Clock className="text-white" size={24} />
                </div>
                <div className="text-2xl font-bold text-white">24h</div>
                <div className="text-sm text-gray-300">Resposta</div>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-gray-700 rounded-lg mx-auto mb-2">
                  <Truck className="text-white" size={24} />
                </div>
                <div className="text-2xl font-bold text-white">+1000</div>
                <div className="text-sm text-gray-300">Produtos</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://www.vhsys.net/ssadistribuidora"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white px-10 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl rounded-lg"
              >
                <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
                Acessar Loja Virtual
                <ArrowRight className="ml-2" size={20} />
              </a>
              <Button
                onClick={() => scrollToSection('contato')}
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-10 py-6 text-lg font-semibold transition-all duration-300"
              >
                Fale Conosco
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};